(function (Lfl, $, undefined) {
    /**
     * @memberOf Lfl
     */
    Lfl.Photos = Lfl.Photos || {};

    (function (Photos, $, undefined) {
        if (Lfl.Files.isLoadedAlready(Lfl.Photos, 'Timeline')) {
            return;
        }

        /*
         |==============================================================================================================
         | Documentation
         |==============================================================================================================
         */

        /**
         *
         *
         * @memberOf Lfl.Photos
         */
        Lfl.Photos.Timeline = Photos.Timeline || {};

        (function (Timeline, $, undefined) {
            /*
             |==========================================================================================================
             | Object definition
             |==========================================================================================================
             */

            let nextPageUrl;
            let selectedTab;
            let currentRequest = null;

            /*
             |----------------------------------------------------------------------------------------------------------
             | Public methods
             |----------------------------------------------------------------------------------------------------------
             */

            /**
             * @param {Object} parameters
             * @param {string} parameters.selectedTab
             * @param {string} parameters.nextPageUrl
             * @memberOf Lfl.Photos.Timeline
             */
            Timeline.init = function(parameters) {
                nextPageUrl = parameters.nextPageUrl;
                selectedTab = parameters.selectedTab;

                registerTabSwitching();
                initInfiniteScroll();

                toggleTabElements(selectedTab);
            }

            Timeline.appendPhotoList = function(result) {
                updatePhotoList(result, true);
            }

            Timeline.performSelection = function(targetUrl) {
                /* Hide old content */
                $('div.photoswipe-thumbnails').hide();

                /* Show loading placeholder */
                $('.photo-list-placeholder').show();

                if (currentRequest !== null) {
                    currentRequest.abort();
                }

                currentRequest = $.ajax({
                    url: targetUrl,
                    dataType: 'html',
                    success: function(result) {
                        $('.scrolling-content').css('transform', 'translate(0px, 0px) translateZ(0px)');

                        updatePhotoList(result, false);

                        /* Hide loading placeholder */
                        $('.photo-list-placeholder').hide();

                        /* Display new content */
                        $('div.photoswipe-thumbnails').show();

                        /* Update pagination url */
                        nextPageUrl = $(result).find('#next-page-url').text();
                        Lfl.Scrolling.InfiniteScrolling.setNextPageUrl(nextPageUrl);
                        currentRequest = null;
                        Lfl.Scrolling.InfiniteScrolling.checkScrollStateToLoad();
                    },
                    error: function(xhr) {
                        currentRequest = null;

                        if (xhr.statusText === "abort") {
                            return;
                        }

                        Lfl.Ajax.ResponseParser.reloadIfUnauthenticated(xhr);
                    }
                });
            }

            /*
             |----------------------------------------------------------------------------------------------------------
             | Private methods
             |----------------------------------------------------------------------------------------------------------
             */

            function updateCurrentUrl() {
                let currentUrl = window.location.href;
                currentUrl = Lfl.Urls.ParametersProcessor.removeSearchParameter(currentUrl, 'tab');
                currentUrl = Lfl.Urls.ParametersProcessor.addSearchParameter(currentUrl, 'tab', selectedTab);

                window.history.replaceState('', '', currentUrl);

                return currentUrl;
            }

            function registerTabSwitching() {
                $('div.secondary-navigation-item').click(function () {
                    selectedTab = $(this).data('lfl-filter');

                    let targetUrl = updateCurrentUrl();
                    Timeline.performSelection(targetUrl);

                    toggleTabElements();
                });
            }

            function toggleTabElements() {
                $('div.secondary-navigation-item.active').removeClass('active');
                $('div.secondary-navigation-item[data-lfl-filter=' + selectedTab + ']').addClass('active');
            }

            function initInfiniteScroll() {
                Lfl.Scrolling.InfiniteScrolling.init({
                    nextPageUrl: nextPageUrl,
                    successCallback: Timeline.appendPhotoList,
                });
            }

            function updatePhotoList(result, useAppend) {
                const monthSectionQuery = '[data-lfl-section-container]';
                const imageSectionListQuery = '[data-lfl-section-items]';

                const $result = $(result);

                const gallery = Lfl.Fist.PhotoswipeInitializer.getGallery();
                // When photoswipe is currently open, append new items
                if (typeof gallery !== 'undefined' && gallery !== null && typeof gallery.options.dataSource !== 'undefined') {
                    $result.find('a').each(function () {
                        const $this = $(this);

                        gallery.options.dataSource.items.push({
                            srcset: $this.attr('data-pswp-srcset'),
                            src:  $this.attr('href'),
                            w: $this.attr('data-pswp-width'),
                            h: $this.attr('data-pswp-height'),
                            element: this
                        });
                    });

                    if (gallery.pswp !== null) {
                        gallery.pswp.refreshSlideContent(gallery.pswp.currSlide.index);
                    }
                }

                if (useAppend) {
                    $result.find('#photo-list').find(monthSectionQuery).each(function () {
                        const id = $(this).attr('id');
                        const $alreadyExisting = $('#' + id);

                        if ($alreadyExisting.length) {
                            // Month label already exists
                            $alreadyExisting.find(imageSectionListQuery).append($(this).find(imageSectionListQuery).html());
                        } else {
                            // Month label needs to be added
                            const $thumbnails = $('#photo-list');
                            $thumbnails.append($(this));
                        }
                    });
                } else {
                    $('#photo-list').html($result.find('#photo-list').html());
                    $('#photo-count').html($result.find('#photo-count').html());
                }

                Lfl.Images.ImagesDefaultFallbackHandler.activate();
            }
        }(Photos.Timeline, jQuery));
    }(Lfl.Photos, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
